export default "__VITE_ASSET__DasEB0pX__"